export default __webpack_public_path__ + "static/media/back.de43211f.svg";